import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "_app_references_modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-9" }
const _hoisted_8 = { class: "text-center mb-9" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "text-gray-400 fw-bold fs-5" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = {
  class: "btn-group d-inline-block",
  role: "group",
  "aria-label": "Color references"
}
const _hoisted_13 = {
  key: 0,
  class: "explanation-text text-center px-6 py-12"
}
const _hoisted_14 = { class: "explanation-text-stopper mt-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "bi bi-check" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "mt-12 mb-15"
}
const _hoisted_17 = { class: "mh-375px scroll-y me-n7 pe-7" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "ms-6" }
const _hoisted_20 = {
  href: "#",
  class: "d-flex align-items-center fs-5 fw-bolder text-dark text-hover-primary"
}
const _hoisted_21 = { class: "badge badge-light fs-8 fw-bold ms-2" }
const _hoisted_22 = { class: "fw-bold text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("h1", _hoisted_9, _toDisplayString(_ctx.translate("usingReferences")), 1),
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.translate("usingIntro")), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", {
                  'btn-success btn-azul':
                    !_ctx.selectedExplanationType ||
                    _ctx.isExplanationTypeSelected(_ctx.explanationTypes._TYPE_1)
                }],
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startExplanation(_ctx.explanationTypes._TYPE_1)))
              }, [
                _createVNode("small", null, _toDisplayString(_ctx.translate("differentiatedStart")), 1)
              ], 2),
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", {
                  'btn-success':
                    !_ctx.selectedExplanationType ||
                    _ctx.isExplanationTypeSelected(_ctx.explanationTypes._TYPE_2)
                }],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startExplanation(_ctx.explanationTypes._TYPE_2)))
              }, [
                _createVNode("small", null, _toDisplayString(_ctx.translate("greaterThan") + " 70%"), 1)
              ], 2),
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", {
                  'btn-warning':
                    !_ctx.selectedExplanationType ||
                    _ctx.isExplanationTypeSelected(_ctx.explanationTypes._TYPE_3)
                }],
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startExplanation(_ctx.explanationTypes._TYPE_3)))
              }, [
                _createVNode("small", null, _toDisplayString(_ctx.translate("greaterThan") + " 40%"), 1)
              ], 2),
              _createVNode("button", {
                type: "button",
                class: ["btn btn-sm", {
                  'btn-danger':
                    !_ctx.selectedExplanationType ||
                    _ctx.isExplanationTypeSelected(_ctx.explanationTypes._TYPE_4)
                }],
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startExplanation(_ctx.explanationTypes._TYPE_4)))
              }, [
                _createVNode("small", null, _toDisplayString(_ctx.translate("lessThan") + " 40%"), 1)
              ], 2)
            ])
          ]),
          (_ctx.explanationText)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("span", {
                  textContent: _toDisplayString(_ctx.explanationText)
                }, null, 8, ["textContent"]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-dark",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.endExplanation()))
                  }, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.translate("understood")), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.helpItems, (helpItem, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed"
                    }, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("div", _hoisted_19, [
                          _createVNode("a", _hoisted_20, [
                            _createTextVNode(_toDisplayString(helpItem.title) + " ", 1),
                            _createVNode("span", _hoisted_21, _toDisplayString(helpItem.position), 1)
                          ]),
                          _createVNode("div", _hoisted_22, _toDisplayString(_ctx.translate(helpItem.description)), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
        ])
      ])
    ])
  ]))
}